export default {
  home: '首頁',
  pageNotFound: '您要訪問的頁面不存在',
  backHome: '回首頁',
  promo: '獎勵',
  wallet: '充值',
  earn: '賺錢',
  me: '我的',
  loginRegister: '登錄 / 註冊',
  walletCenter: '充值中心',
  withdrawTitle: '提現',
  notice: '消息通知',
  support: '在線客服',
  back: '返回',
  close: '關閉',
  deposit: '充值',
  brand: 'BetCorgi',
  copySuccess: '已複製到剪貼板 · Copied',
  copyFailed: '複製失敗，請手動複製',
  search: '搜索',
  /** 右下角主題浮標（演示） */
  theme: {
    menu: '主題 · 演示',
    aria: '主題切換 · 演示',
    title: '切換主題(演示)',
    darkPurple: '深紫',
    darkGold: '深金',
    lightGold: '白金',
    lightBlue: '白藍',
  },
  /** 時間口徑統一（規範 6.2）：今天 / 昨天、區間、站點時間提示、倒計時的唯一文案來源 */
  time: {
    /** 列表智能格式：今天 22:30 / 昨天 22:30（按設備日曆） */
    today: '今天',
    yesterday: '昨天',
    /** 倒計時滿一天的前綴：1天 02:03:04 */
    days: '{n}天',
    /** 篩選區間（按站點日界，與接口 time_range / period 同名） */
    range: {
      today: '今日',
      yesterday: '昨日',
      last_7d: '近 7 日',
      last_30d: '近 30 日',
      this_week: '本週',
      last_week: '上週',
      this_month: '本月',
      last_month: '上月',
    },
    siteTime: '站點時間',
    siteTimeWithOffset: '站點時間 {offset}',
    /** 設備時區 ≠ 站點時區時，出現在「今日 / 近 7 日 / 本月」篩選下方 */
    siteTimeHint: '按站點時間（{offset}）統計',
    /** 規則文案括注；後半句只在設備時區與站點時區不同時出現 */
    siteClockNote: '（站點時間 {offset}）',
    siteClockNoteLocal: '（站點時間 {offset}，即你當地 {local}）',
    /** 業務日（統計日等）原樣顯示時的標註 */
    siteDate: '站點日期',
    dailyReset: '每日 00:00{note}重置',
    resetIn: '距離重置',
    /** 有絕對到期時刻的：一天內倒計時，更久顯示本地時刻 */
    expiresIn: '{countdown} 後過期',
    expiresAt: '{date} 過期',
    /** 等待時長（鎖定 / 頻控提示），分鐘向上取整：1 小時 58 分 / 2 小時 / 58 分鐘 */
    waitHm: '{h} 小時 {m} 分',
    waitH: '{h} 小時',
    waitM: '{m} 分鐘',
    /** 充值渠道每日時段：09:00–23:00（站點時間 UTC-3） */
    dailyWindow: '{window}（{zone}）',
  },
}
